import { evaluate } from './flip';
import { daysBetween } from './format';
import { STATUS_LABEL, type Car } from './types';

const cell = (v: string | number): string => {
  let s = String(v);
  // A leading = + - @ would be run as a formula by spreadsheets.
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const round2 = (n: number) => Math.round(n * 100) / 100;

/** One row per car, planned and actual, for a spreadsheet or your records. */
export function carsToCsv(cars: readonly Car[]): string {
  const header = [
    'Car', 'Reg', 'Status', 'Bought on', 'Sold on', 'Days held', 'Cash invested', 'Sale price',
    'Profit (plan)', 'Profit (now)', 'ROI % (now)', 'Notes',
  ];
  const rows = cars.map((c) => {
    const plan = evaluate(c.planned);
    const now = evaluate(c.deal);
    const days = daysBetween(c.boughtOn, c.soldOn);
    return [
      c.title, c.reg, STATUS_LABEL[c.status], c.boughtOn, c.soldOn, days ?? '', round2(now.cashInvested),
      round2(c.deal.salePrice), round2(plan.profit), round2(now.profit), round2(now.roiPct), c.notes,
    ].map(cell).join(',');
  });
  return [header.map(cell).join(','), ...rows].join('\r\n') + '\r\n';
}
